module.exports = __webpack_public_path__ + "static/img/mpdpImgTwo3.449eb99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpdpImgTwo3.png
// module id = pgBF
// module chunks = 2